import React from 'react'
import {BoxBackground, CustomHeader2, CustomP, CustomP2White, Section} from "../components/Headers"
import {Typography} from "antd"
import {useIsMobile} from "../components/LayoutWrapper"
import ChatDemo from '../icons/chat.png'

const {Title} = Typography

const ChatHeader: React.FC = () => {
    const isMobile = useIsMobile()

    return (
        <BoxBackground
            style={{
                height: 'auto',
                marginBottom: '10vh'
            }}
        >
            <Title
                style={{
                    marginTop: '100px',
                    textAlign: 'center'
                }}
            >
                Explore Game Data Through Chat
            </Title>
            <CustomP
                style={{
                    marginLeft: isMobile ? undefined : '10vh',
                    marginRight: isMobile ? undefined : '10vh',
                    textAlign: 'center'
                }}
            >
                Ask questions about the game and get detailed answers.
            </CustomP>
        </BoxBackground>
    )
}

const ChatSection: React.FC = () => {
    const isMobile = useIsMobile()
    return (
        <Section>
            <div
                style={{
                    marginLeft: isMobile ? '0vh' : '5vh',
                    marginRight: isMobile ? '0vh' : '10vh'
                }}
            >
                <CustomHeader2>
                    Chat
                </CustomHeader2>
                <CustomP2White>
                    Interact with game data using natural language. Ask questions about player and team performance.
                    <br/>
                    <br/>

                    <img
                        style={{
                            width: isMobile ?'90%':'60%'
                        }}
                        src={ChatDemo}
                    />

                </CustomP2White>
            </div>
        </Section>
    )
}


const Chat: React.FC = () => {
    return (
        <div>
            <ChatHeader/>
            <ChatSection/>
        </div>
    )
}

export default Chat